import moment from 'moment'
import logger from './logger'

/**
 * Convert date and time to Singapore timezone (UTC+8)
 * @param {string} date - Date string in YYYY-MM-DD format
 * @param {string} time - Time string in HH:mm format
 * @param {string} returnFormat - 'object' for {date, time, dateTime} or 'normal' for string format
 * @returns {object|string} Formatted date/time object or ISO datetimeoffset string
 */
const convertToSingaporeDateTime = (date, time, returnFormat = 'object') => {
    // Validate inputs
    if (!date || !time) {
        logger.error('Invalid date or time input:', { date, time })
        return returnFormat === 'normal' ? null : { date, time, dateTime: null }
    }

    // Create moment object in Singapore timezone (UTC+8)
    const momentObj = moment(`${date} ${time}:00`, 'YYYY-MM-DD HH:mm:ss').utcOffset('+08:00')

    // Check if moment object is valid
    if (!momentObj.isValid()) {
        logger.error('Invalid moment object created from:', { date, time })
        return returnFormat === 'normal' ? null : { date, time, dateTime: null }
    }

    // Return in requested format
    if (returnFormat === 'normal') {
        // Return ISO datetimeoffset format: "YYYY-MM-DD HH:mm:ss Z"
        return momentObj.format('YYYY-MM-DD HH:mm:ss Z')
    } else {
        // Return object format - use Date object for compatibility with moment()
        // This is the most reliable format for passing to moment() constructor
        return {
            date,
            time,
            dateTime: momentObj.toDate(), // Return as Date object for moment() compatibility
        }
    }
}

export { convertToSingaporeDateTime }
